import ApiClient, { ApiConfig } from '../../../ApiClient';

import { AlgonomyApiBaseService } from './service';
import config from 'config-base';
import AlgonomyBase from '../AlgonomyBase';

export default class AlgonomyApiBase extends AlgonomyBase implements AlgonomyApiBaseService {
  constructor(protected apiClient: ApiClient) {
    super();
  }

  public async get(path: string, params: URLSearchParams, cookie?: string, cloudfareIp?: string): Promise<Response> {
    const urlParams = new URLSearchParams([['brandCode', config.brandCode], ...params]);

    let conifgs: ApiConfig = {
      credentials: cookie ? 'include' : undefined,
      headers: cookie ? { Cookie: cookie } : undefined,
    };

    if (cloudfareIp) {
      conifgs = {
        ...conifgs,
        headers: { ...conifgs.headers, 'CF-Connecting-IP': cloudfareIp },
      };
    }
    return this.apiClient.get(`${path}?${urlParams}`, conifgs);
  }
}
